//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/StructureDesign.js";
import "../no/Object.js";
import "../StructureDesign/StructureDesign.StructureDesignSession.js";
let d=[[],[[["curves"],"UpdateStructure",{},1,0],[["tgNodes","tgStructurePart"],"PackMemberNodes",{},2,0],[["tgNodes","tgStructurePart"],"UnpackMemberNodes",{},2,0],[["consolidateListNodeTag"],"RemoveConsolidateList",{},1,0],[["components"],"RemoveFeaturesInsideEndCapComponents",{},1,0],[["components"],"RemoveFeaturesInsideMemberComponents",{},1,0],[["components"],"RemoveFeaturesInsideMountingFeetComponents",{},1,0],[["components"],"RemoveFeaturesInsideBoltedConnectionComponents",{},1,0],[["components"],"RemoveFeaturesInsideStiffenerComponents",{},1,0],[["components"],"RemoveFeaturesInsidePadComponents",{},1,0],[["tWeldmentNode","index"],"DeleteWeldmentNode",{},2,0],[["index","tgTargetNode","tgNodes"],"ReparentPartNodes",{},3,0],[["displayType"],"UpdateDisplayColorType",{},1,0],[["tgNodes"],"RemoveFromConsolidateList",{},1,0]],[]];
SPLM.StructureDesign.ContextMenu = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.StructureDesign.ContextMenu";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.StructureDesign.ContextMenu.DisplayColorType = Object.freeze({
    "ShowStock" : "ShowStock", "ShowWeld" : "ShowWeld"});

export default SPLM;